import { cn } from '../../lib/cn';
import type { MarketplaceAIRow } from '../../enterprisega/framework';

type Props = { items?: MarketplaceAIRow[] };

export function MarketplaceAIOpsPanel({ items = [] }: Props) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.area} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-medium">{item.area}</p>
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'healthy' || item.status === 'active' || item.status === 'optimized'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {item.status}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.detail}</p>
        </div>
      ))}
    </div>
  );
}
